import { Stack } from "@mui/material"

import { Breadcrumbs, type FC, type FCWC, type ResponsiveImageType } from ".."
import { LinkType } from "../../graphql/types"
import HeroMedia from "./HeroMedia"

type Hero4Props = {
  media: ResponsiveImageType[]
  path?: LinkType[]
  reducedHeight?: boolean
}

const Hero4: FC<Hero4Props> = ({ media, path = [], reducedHeight = false }) => {
  return (
    <HeroSection reducedHeight={reducedHeight}>
      <HeroMedia media={media} />
      <HeroContainer>{path && <Breadcrumbs items={path} />}</HeroContainer>
    </HeroSection>
  )
}

export default Hero4

/** A sub-component for the section container of the hero content */
const HeroSection: FCWC<{ reducedHeight?: boolean }> = ({
  children,
  reducedHeight = false,
  ...props
}) => (
  <Stack
    component="header"
    alignItems="stretch"
    justifyContent="flex-end"
    width="100%"
    position="relative"
    height={reducedHeight ? 250 : { xs: 540, md: 500 }}
    sx={{ isolation: "isolate" }}
    {...props}
  >
    {children}
  </Stack>
)

/** A sub-component for the container of the hero content */
const HeroContainer: FCWC<{}> = ({ children }) => (
  <Stack
    justifyContent="flex-end"
    height={{ xs: 476 /* 540 - 64 */, md: 370 /* 500 - 130 */ }}
    p={3}
    position="relative"
    zIndex={3}
  >
    {children}
  </Stack>
)
